import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "shortcut-key" }
const _hoisted_2 = {
  key: 0,
  class: "key key-mod"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "key key-mod"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = {
  key: 4,
  class: "key key-mod"
}
const _hoisted_7 = { key: 5 }
const _hoisted_8 = {
  key: 6,
  class: "key key-mod"
}
const _hoisted_9 = { key: 7 }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["^href"]

import { Shortcut } from "@/models/shortcut";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShortcutKey',
  props: {
  shortcut: {
    type: Object as PropType<Shortcut>,
    required: true
  }
},
  setup(__props) {

const { shortcut } = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", _hoisted_1, [
      (__props.shortcut.command_key)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Command"))
        : _createCommentVNode("", true),
      (__props.shortcut.command_key)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " + "))
        : _createCommentVNode("", true),
      (__props.shortcut.ctrl_key)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Ctrl"))
        : _createCommentVNode("", true),
      (__props.shortcut.ctrl_key)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " + "))
        : _createCommentVNode("", true),
      (__props.shortcut.alt_key)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Alt"))
        : _createCommentVNode("", true),
      (__props.shortcut.alt_key)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " + "))
        : _createCommentVNode("", true),
      (__props.shortcut.shift_key)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Shift"))
        : _createCommentVNode("", true),
      (__props.shortcut.shift_key)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, " + "))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: "key",
        textContent: _toDisplayString(__props.shortcut.shortcut_key)
      }, null, 8, _hoisted_10)
    ]),
    _createElementVNode("a", {
      class: "shortcut-key-link",
      "^href": `/shortcut/${__props.shortcut.id}`
    }, _toDisplayString(__props.shortcut.name), 9, _hoisted_11)
  ], 64))
}
}

})